<template>
  <div>
    <div class="r-main-bottom--standard">
      <iframe id="jks-iframe"
              :src="originUrl"
              frameborder="0"
              align="left"
              scrolling="no"
              width="100%"
              style="height: 600px;"
              name="JKS"/>
    </div>
  </div>
</template>


<script>
import $ from 'jquery';
// console.log(window.location.href);
const originUrl = window.location.origin;
// var originUrl = "http://www.johanniterhausnotruf.de/konfigurator";

function receivedMessage(event) {
  // console.log(event.origin, event);
  if (event.origin !== originUrl) return;

  const $iframe = $('#jks-iframe');

  $iframe.on('load', function() {
    // console.log('DOC', this.contentWindow.document.querySelectorAll('input.is-danger')[0]);
    // document.documentElement.scrollTop = document.getElementById('jks-iframe').offsetTop;
  });

  /* Will be passed like {height: 300} */
  const dataObj = event.data;
  // if ("checkErrors" in dataObj) {
  //   console.log($("input.is-danger"));
  // }
  if (dataObj) {
    /* animating height in our case */
    $iframe.stop().animate(dataObj, 150, function() {
      $('html, body').animate({ scrollTop: 0 }, 'fast');
    });
  }
}

window.addEventListener('message', receivedMessage, false);

export default {
  data() {
    return {
      originUrl: originUrl
    };
  },
  // created() {
  //   console.log();
  // },
  // mounted() {
  //   console.log(document.getElementById("jks-iframe"));
  //   document.getElementById("jks-iframe").onload = function() {
  //     this.contentWindow.scrollTo(0, 200);
  //   };
  // },
  methods: {}
};
</script>

<style scoped>
.r-main-bottom--standard {
  padding: 1000px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Iframe.vue